import { http } from "../http";

export const getProductsHTTP = async data => {
  return http.post("GetProducts", data);
};
